import _ from "lodash";
import { DropzoneAreaBase, FileObject } from "material-ui-dropzone";
import { useSnackbar } from "notistack";

const DEFAULT_MAX_SIZE_MB = 100;

export type FilePickerProps = {
  onPickFile: (file: File) => void;
  dropzoneText: string;
  requiredMimeType?: string;
  requiredMimeTypeDescription?: string;
  maxSizeMB?: number | null;
};

export default function FilePicker({
  onPickFile,
  dropzoneText,
  requiredMimeType,
  requiredMimeTypeDescription,
  maxSizeMB: maxSizeMbOverride
}: FilePickerProps): JSX.Element {
  const maxSizeMB = _.max([maxSizeMbOverride || 0, DEFAULT_MAX_SIZE_MB])!;

  const snackbar = useSnackbar();

  function onChange(files: FileObject[]) {
    if (!files?.[0]) {
      return;
    }

    if (files.length > 1) {
      snackbar.enqueueSnackbar("You may only upload one file.", {
        variant: "error"
      });
      return;
    }

    const file = files[0].file;
    if (file.size > maxSizeMB * 1024 * 1024) {
      snackbar.enqueueSnackbar(`File size must be less than ${maxSizeMB} MB.`, {
        variant: "error"
      });
      return;
    }

    if (requiredMimeType && file.type !== requiredMimeType) {
      snackbar.enqueueSnackbar(
        `You must upload a ${
          requiredMimeTypeDescription || requiredMimeType
        } file.`,
        { variant: "error" }
      );
      return;
    }

    onPickFile(file);
  }

  return (
    <DropzoneAreaBase
      onAdd={onChange}
      dropzoneText={dropzoneText}
      showAlerts={false}
      maxFileSize={Number.MAX_SAFE_INTEGER}
      showPreviewsInDropzone={false}
      fileObjects={[]} // disable behavior where it stores multiple files
    />
  );
}
